/* eslint-disable no-unused-vars */
import 'focus-visible'
import Globals from './globals-class'

const globals = new Globals()
